// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F7i9","col":"styles_col__2n758"};